module.exports = __webpack_public_path__ + "static/img/2198_phase_function_Paper_PointsHejduk_Prediction.c2e77c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2198_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Bp7b
// module chunks = 0